import Router from 'next/router';
// useRouter hook will cause the component to re-render when the router changes. So use Router.push instead.
export var push = function push(url) {
  var as = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
  var shallow = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  return Router.push(url, as, {
    shallow: shallow
  });
};